import React, { useState } from "react";
import styles from "./imageModal.module.css";
import { Icons } from "../../../code/IconHandler";
import { toast } from "react-toastify";
const ImageModal = ({ src, alt, onClose }) => {
    const [zoom, setZoom] = useState(1);

    if (!src) return null;

    const zoomIn = () => setZoom((z) => Math.min(z + 0.2, 3));
    const zoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.5));
    const resetZoom = () => setZoom(1);

    const handleDownload = async () => {
        try {
            const response = await fetch(src, { mode: "cors" }); // `no-cors` won't let you access blob
            if (!response.ok) throw new Error("Network response was not ok");

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = alt || "image";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url); // Cleanup
        } catch (err) {
            console.error("Download failed:", err);
            toast.info("Bild konnte nicht heruntergeladen werden.");
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalForm} onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}


                {/* Zoom Controls */}
                <div className={styles.zoomControls}>
                    <button onClick={handleDownload} title="Bild herunterladen">
                        <Icons.Download size={20} />
                    </button>
                    <div className={styles.center}>
                        <button onClick={zoomOut} title="Verkleinern">
                            <Icons.ZoomOut size={20} />
                        </button>
                        <button onClick={resetZoom} title="Zurücksetzen">
                            <Icons.Reset size={20} />
                        </button>
                        <button onClick={zoomIn} title="Vergrößern">
                            <Icons.ZoomIn size={20} />
                        </button>
                    </div>
                    <button onClick={onClose} title="Schließen">
                        <Icons.X size={20} />
                    </button>
                </div>

                {/* Scrollable Zoomable Image */}
                <div className={styles.imageScrollContainer}>
                    <img
                        src={src}
                        alt={alt || "Zoomed"}
                        className={styles.modalImage}
                        style={{
                            width: `${zoom * 100}%`,
                            height: "auto",
                            display: "inline-block", // important!
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ImageModal;
